// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grafana-inner button {
  width: unset;
}

.grafanaTitle {
  width: 100%;
  text-align: center;
  margin: 0px;
}

.grafanaType {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.grafanaType > label {
  width: max-content;
}

div.MuiFormControl-root.MuiTextField-root.css-z3c6am-MuiFormControl-root-MuiTextField-root > div {
  color: var(--primaryFontTheme);
}
div.MuiFormControl-root.MuiTextField-root.css-z3c6am-MuiFormControl-root-MuiTextField-root > div div > button {
  color: #35afaf;
}
div.MuiFormControl-root.MuiTextField-root.css-z3c6am-MuiFormControl-root-MuiTextField-root > div div > button:disabled {
  color: #4F4F4F;
}

div.MuiFormControl-root.MuiTextField-root.css-z3c6am-MuiFormControl-root-MuiTextField-root > div > fieldset {
  border-color: #35afaf;
}

div.MuiFormControl-root.MuiTextField-root.css-z3c6am-MuiFormControl-root-MuiTextField-root > div.Mui-disabled > fieldset {
  border-color: #4F4F4F;
}

.grafana-slider {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  width: 25%;
}

#grafana-diagram-container #dropdown-container .dropdown {
  width: 50%;
}
#grafana-diagram-container h2 {
  margin: 24px 0;
}
#grafana-diagram-container .chartOptions {
  gap: 32px;
}
#grafana-diagram-container button[type=submit] {
  padding: 14px 24px;
  margin-bottom: 24px;
}

@media only screen and (max-width: 1000px) {
  .grafanaType {
    flex-direction: column;
    align-items: unset;
  }
  .grafana-slider {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Grafana/grafanaDiagram.scss"],"names":[],"mappings":"AACE;EACE,YAAA;AAAJ;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EAEE,8BAAA;AAFF;AAIE;EACE,cAAA;AAFJ;AAKE;EACE,cAAA;AAHJ;;AAOA;EAGE,qBAAA;AANF;;AASA;EAGE,qBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;AARF;;AAaK;EACC,UAAA;AAVN;AAcE;EACE,cAAA;AAZJ;AAeE;EACE,SAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,mBAAA;AAdJ;;AAkBA;EACE;IACE,sBAAA;IACA,kBAAA;EAfF;EAiBA;IACE,WAAA;EAfF;AACF","sourcesContent":[".grafana-inner {\n  button {\n    width: unset;\n  }\n}\n\n.grafanaTitle {\n  width: 100%;\n  text-align: center;\n  margin: 0px\n}\n\n.grafanaType {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.grafanaType > label {\n  width: max-content;\n}\n\ndiv.MuiFormControl-root.MuiTextField-root.css-z3c6am-MuiFormControl-root-MuiTextField-root\n  > div {\n  color: var(--primaryFontTheme);\n\n  div > button {\n    color: #35afaf;\n  }\n\n  div > button:disabled {\n    color: #4F4F4F;\n  }\n}\n\ndiv.MuiFormControl-root.MuiTextField-root.css-z3c6am-MuiFormControl-root-MuiTextField-root\n  > div\n  > fieldset {\n  border-color: #35afaf;\n}\n\ndiv.MuiFormControl-root.MuiTextField-root.css-z3c6am-MuiFormControl-root-MuiTextField-root\n  > div.Mui-disabled\n  > fieldset {\n  border-color: #4F4F4F;\n}\n\n.grafana-slider {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  align-items: center;\n  width: 25%;\n}\n\n#grafana-diagram-container {\n  #dropdown-container {\n     .dropdown {\n      width: 50%;\n     }\n  }\n\n  h2 {\n    margin: 24px 0;\n  }\n\n  .chartOptions {\n    gap: 32px;\n  }\n\n  button[type=submit] {\n    padding: 14px 24px;\n    margin-bottom: 24px;\n  }\n}\n\n@media only screen and (max-width: 1000px) {\n  .grafanaType {\n    flex-direction: column;\n    align-items: unset;\n  }\n  .grafana-slider {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
